export const SMETA_STATUS = {
    'rework': 'доработка',
    'realization': 'реализация',
    'oncheck': 'на проверке'
}

export const initComments = [
    {
        title: 'Подопечный (ая) обратился в',
        comment: ''
    },
    {
        title: 'с просьбой помочь ему (ей) в',
        comment: ''
    },
    {
        title: 'Подопечным были предоставлены личные документы',
        comment: ''
    },
    {
        title: 'медицинские документы',
        comment: ''
    },
    {
        title: 'Мы связались с подопечным. После получения документов и ознакомления с ними, мы',
        comment: ''
    }, {
        title: 'Дополнительно у подопечного мы запросили:',
        comment: ''
    }, {
        title: 'Дополнительно подопечного мы направили:',
        comment: ''
    }, {
        title: 'Дополнительно мы запросили информацию у:',
        comment: ''
    }, {
        title: 'Проблемы при обработке заявки:',
        comment: ''
    }, {
        title: 'Завершаем обработку заявки:',
        comment: '',
    }, {
        title: 'Решение принято на основании вышеизложенных данных',
        comment: ''
    }, {
        title: 'Заключение: просьбу подопечного считаем',
        comment: ''
    }, {
        title: 'и',
        comment: ''
    }]